import React, { useState } from 'react';
import { Card, Button, Modal, Form, Radio, Tree, message, Progress, Tag, Input, Divider } from 'antd';
import { DownloadOutlined, FileExcelOutlined, FileTextOutlined, FileDoneOutlined } from '@ant-design/icons';

const DataExportModule = () => {
  const [visible, setVisible] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [selectedKeys, setSelectedKeys] = useState([]);

  const treeData = [
    {
      title: '碳储量估算结果', key: 'carbon_estimation',
      children: [
        { title: '区域A-2023年度', key: 'region_a_2023' },
        { title: '区域B-2023年度', key: 'region_b_2023' },
      ],
    },
    {
      title: '可视化图层数据', key: 'layers',
      children: [
        { title: '植被覆盖图', key: 'layer_veg' },
        { title: '土壤有机碳分布', key: 'layer_soil' },
      ],
    },
  ];

  const handleExport = () => {
    if (selectedKeys.length === 0) return message.warning('请至少选择一项数据！');
    setExporting(true);
    let p = 0;
    const interval = setInterval(() => {
      p += 10;
      setProgress(p);
      if (p >= 100) {
        clearInterval(interval);
        setExporting(false);
        setVisible(false);
        message.success('导出成功！文件已下载。');
        setProgress(0);
      }
    }, 300);
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="数据导出" extra={<Button type="primary" icon={<DownloadOutlined />} onClick={() => setVisible(true)}>开始导出</Button>}>
        <p>本模块支持将碳储量反演结果、可视化图层及元数据导出为多种通用格式（CSV, Excel, JSON）。</p>
        <Divider orientation="left">最近导出记录</Divider>
        <ListMock name="carbon_report_2024.xlsx" status="success" />
        <ListMock name="layer_data_v2.json" status="success" />
      </Card>

      <Modal
        title="数据导出设置"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setVisible(false)} disabled={exporting}>取消</Button>,
          <Button key="export" type="primary" loading={exporting} onClick={handleExport}>导出</Button>
        ]}
      >
        <Form layout="vertical">
          <Form.Item label="选择数据">
            <Tree checkable treeData={treeData} onCheck={keys => setSelectedKeys(keys)} />
          </Form.Item>
          <Form.Item label="导出格式">
            <Radio.Group defaultValue="csv">
              <Radio value="csv"><FileTextOutlined /> CSV</Radio>
              <Radio value="excel"><FileExcelOutlined /> Excel</Radio>
              <Radio value="json"><FileDoneOutlined /> JSON</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="文件名"><Input placeholder="默认使用时间戳命名" /></Form.Item>
          {exporting && <Progress percent={progress} status="active" />}
        </Form>
      </Modal>
    </div>
  );
};

const ListMock = ({ name, status }) => (
  <div style={{ padding: '10px 0', borderBottom: '1px dashed #eee', display: 'flex', justifyContent: 'space-between' }}>
    <span>{name}</span>
    <Tag color={status === 'success' ? 'green' : 'red'}>{status === 'success' ? '已完成' : '失败'}</Tag>
  </div>
);

export default DataExportModule;